import React from "react";

import "./LoadingSpinner.css";

const LoadingSpinner = props => (
  <div className={`${props.asOverlay && "loading-spinner__overlay"}`}>
    <div className={"loading-spinner-spin"}>
      <div className="loading-spinner">
        {[...Array(8)].map((e, i) => (
          <div key={i}>
            <div></div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default LoadingSpinner;
